import * as React from "react";
export const CouponBtn = (props) => {
    const { coupon, index = 0, handleClick } = props;
    const onClick = () => {
        handleClick(coupon === null || coupon === void 0 ? void 0 : coupon.code, index);
    };
    return React.createElement("img", { src: coupon === null || coupon === void 0 ? void 0 : coupon.img, onClick: onClick });
};
